module.exports = __webpack_public_path__ + "img/LREXshapeDriverWoman.a8a6e82b.png";